<div class="wrapper">
    <app-header></app-header>
    <div class="min-page-height">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</div>